import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import EmailVerifier from './email-verfier';
import { RootState } from '../../store/root-reducer';

const EmailVerifierContainer = memo(() => {
  const isDemoAccount = useSelector(
    (state: RootState) => state?.home?.isDemoAccount,
  );
  return <EmailVerifier isDemoAccount={isDemoAccount} />;
});

export default EmailVerifierContainer;
